// https://github.com/facebook/react/issues/11538#issuecomment-417504600
// Adjusted their console.error to console.log since we hook ErrorLog into
// console.error.

function doReactFix() {
	/* eslint-disable no-console */
	/* eslint-disable prefer-rest-params */
	if (typeof Node === "function" && Node.prototype) {
		const originalRemoveChild = Node.prototype.removeChild;
		Node.prototype.removeChild = function(child) {
			if (child.parentNode !== this) {
				if (console) {
					console.log(
						"Cannot remove a child from a different parent",
						child,
						this
					);
				}
				return child;
			}
			return originalRemoveChild.apply(this, arguments);
		};

		const originalInsertBefore = Node.prototype.insertBefore;
		Node.prototype.insertBefore = function(newNode, referenceNode) {
			if (referenceNode && referenceNode.parentNode !== this) {
				if (console) {
					console.log(
						"Cannot insert before a reference node from a different parent",
						referenceNode,
						this
					);
				}
				return newNode;
			}
			return originalInsertBefore.apply(this, arguments);
		};
	}
	/* eslint-enable no-console */
	/* eslint-enable prefer-rest-params */
}

module.exports = doReactFix;
